module.exports = __webpack_public_path__ + "static/media/hero04.efb95f7c.jpg";